import React, { useEffect } from "react";
import { ExerciseList } from "@/components/exercises/ExerciseList";
import { ExerciseDialog } from "@/components/exercises/ExerciseDialog";
import { Exercise as UIExercise } from "@/components/exercises/exercise.interfaces";
import { useAppToast } from "@/hooks/useAppToast";
import { useLevelTestGroupExerciseContext } from "./LevelTestGroupExerciseContext";

export const LevelTestGroupExercises: React.FC = () => {
  const toast = useAppToast();
  
  const {
    state: { exercises, isRefreshing, error },
    refreshExercises,
    deleteExercise,
    updateExercise,
    addExercise,
    openDialog,
    closeDialog,
    dialogOpen,
    editingExercise,
    batchUpdateExercisesSortOrder
  } = useLevelTestGroupExerciseContext();

  useEffect(() => {
    refreshExercises();
  }, []);

  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error}`);
    }
  }, [error, toast]);

  const handleDelete = async (exerciseId: string | number) => {
    await deleteExercise(String(exerciseId));
  };

  const handleSave = async (exercise: UIExercise) => {
    const existingIndex = exercises.findIndex((ex) => ex.id === exercise.id);

    if (existingIndex !== -1) {
      await updateExercise(exercise);
    } else {
      await addExercise(exercise);
    }
  };

  const handleExerciseClick = (exerciseId: string | number) => {
    const exercise = exercises.find(ex => ex.id === exerciseId);
    if (exercise) {
      openDialog(exercise as unknown as UIExercise);
    }
  };

  return (
    <div className="space-y-4">
      {isRefreshing && (
        <div className="text-sm text-blue-500">Atualizando exercícios...</div>
      )}

      <ExerciseList
        exercises={exercises as any[]}
        onDelete={handleDelete}
        onEdit={handleExerciseClick}
        onExerciseClick={handleExerciseClick}
        context="levelTestGroup"
        openDialog={openDialog}
        batchUpdateExercisesSortOrder={batchUpdateExercisesSortOrder}
      />

      <ExerciseDialog 
        onSave={handleSave}
        dialogOpen={dialogOpen}
        closeDialog={closeDialog}
        editingExercise={editingExercise}
      />
    </div>
  );
};
